import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";

gsap.registerPlugin(ScrollTrigger, SplitText);

function animateTitle() {
  const titles = document.querySelectorAll(".animate__title");
  if (!titles.length) return;
  const textElements = Array.from(titles).flatMap((title) =>
    Array.from(title.querySelectorAll("p, h1, h2, h3, h4, h5, h6"))
  );
  const tweens = new Map();
  let resizeTimeout;

  function buildAnimations() {
    textElements.forEach((element) => {
      const previousTween = tweens.get(element);
      const hasPlayed = previousTween && previousTween.progress() === 1;

      if (previousTween) previousTween.kill();
      if (element._split) element._split.revert();
      if (!element.offsetParent) return;

      const split = new SplitText(element, {
        type: "lines,words",
        linesClass: "line-split",
        wordsClass: "word-split",
      });
      element._split = split;

      split.lines.forEach((line) => {
        line.style.overflow = "hidden";
      });

      const tween = gsap.fromTo(split.words, { yPercent: 100 }, {
        yPercent: -5,
        duration: 0.3,
        ease: "power2.out",
        stagger: 0.04,
        scrollTrigger: {
          trigger: element,
          start: "top 70%",
          end: "top 20%",
          scrub: false,
          markers: false,
        },
      });

      if (hasPlayed || element.getBoundingClientRect().top <= window.innerHeight * 0.7) {
        tween.progress(1);
      }

      tweens.set(element, tween);
    });
  }

  function rebuildAfterResize() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      requestAnimationFrame(() => {
        buildAnimations();
        ScrollTrigger.sort();
        ScrollTrigger.refresh();
      });
    }, 500);
  }

  buildAnimations();
  window.addEventListener("resize", rebuildAfterResize);
  window.addEventListener("orientationchange", rebuildAfterResize);
}

export default animateTitle;
